import { GetApp as DownloadIcon } from "@mui/icons-material";
import ButtonOrMenuItem from "atoms/ButtonOrMenuItem";
import { apiHost, apiPath } from "misc/settings";
import { SyntheticEvent } from "react";

type DownloadInvoicesButtonOrMenuItemPropsType = {
  ids: number[] | undefined;
  label?: string;
  disabled?: boolean;
  closeMenu?: () => void;
  tooltipTitle?: string | null;
  iconOnly?: boolean;
};

export default function DownloadInvoicesButtonOrMenuItem(props: DownloadInvoicesButtonOrMenuItemPropsType) {
  const { ids = [], label = null, closeMenu, disabled, iconOnly = false, ...rest } = props;

  const handleDownload = (event: SyntheticEvent) => {
    window.open(`${apiHost}${apiPath}/invoices/download/?ids=${ids.toString()}`, "_blank")?.focus();
    event.preventDefault();
    event.stopPropagation();
  };

  return (
    <ButtonOrMenuItem
      closeMenu={closeMenu}
      label={iconOnly ? null : (label || "ra.action.download")}
      disabled={disabled || ids.length === 0}
      smartCount={ids.length}
      onClick={(event: SyntheticEvent) => handleDownload(event)}
      sx={{ px: iconOnly ? 1 : 3, minWidth: iconOnly ? 0 : "auto"}}
      {...rest}
    >
      <DownloadIcon />
    </ButtonOrMenuItem>
  );
}
